import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {repoAppBuilder} from '@github-ui/repo-app-builder'

import type {CommitPayload} from '../types/commit-types'

export function buildCommitPathRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('commitPathRoute', {
    path: '/:owner/:repo/commit/:oid/:path/*',
    queries: [
      mainQuery<CommitPayload>({
        queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: searchParams.toString()}),
      }),
    ],
  })
}

export const commitPathRoute = buildCommitPathRoute(repoAppBuilder)
